import React from 'react';
import {Pressable, StyleSheet, Text, View, ScrollView} from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import CampTypes from '../../../../data/CampTypes';

const CampCategory = ({camp, setCamp}) => {
    const [selectedCampTypes, setSelectedCampTypes] = React.useState([]);

    const handleSelectCampType = (campType) => {
        setSelectedCampTypes([campType]);

        setCamp((prevState) => ({
            ...prevState,
            campCategory: campType.iconName,
        }));
    };

    return (
        <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
            <View style={styles.field}>
                <Text style={styles.title}>Camp Category</Text>
                <Text style={styles.subtitle}>Tell us the kind of camp you are hosting.</Text>
            </View>

            <View style={styles.campTypeContainer}>
                {CampTypes.map((campType) => (
                    <Pressable
                        key={campType.iconName}
                        style={[
                            styles.campTypeBanner,
                            {backgroundColor: (selectedCampTypes.includes(campType)) ? '#d3d3d3' : '#fff', flexBasis: '30%'}
                        ]}
                        onPress={() => handleSelectCampType(campType)}
                    >
                        <MaterialIcons name={campType.iconName as any} size={22} />
                        <Text style={styles.campTypeText}>{campType.text}</Text>
                    </Pressable>
                ))}
            </View>
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    contentContainer: {
        paddingHorizontal: 120,
        paddingTop: 40,
        paddingBottom: 40,
        minHeight: 450,
    },
    field: {
        flexDirection: 'column',
        marginBottom: 30,
    },
    title: {
        fontSize: 35,
        color: 'black',
        fontWeight: '600',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 15,
        color: 'grey',
    },
    campTypeContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    campTypeBanner: {
        flex: 1,
        margin: 5,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 15,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: '#ddd',
    },
    icon: {
        marginRight: 10,
    },
    campTypeText: {
        fontSize: 18,
        marginLeft: 10,
        color: '#333',
    },
});

export default CampCategory;
